var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[_c('div',{staticClass:"app-container home"},[_c('a-card',{attrs:{"bordered":false}},[_c('a-tabs',{attrs:{"default-active-key":"1","tab-position":"left"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"本地邮件"}},[_c('local')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"阿里邮件"}},[_c('aliyun')],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }